import styled from "styled-components"
import {
  Icon as BaseIcon,
  type IconProps as BaseIconProps,
} from "~/ur-react-components"

export declare type IconType =
  | "light"
  | "regular"
  | "solid"
  | "brand"
  | "duotone"

type StyledIconProps = {}

const StyledIcon = styled(BaseIcon)<StyledIconProps>``

export interface IconProps extends BaseIconProps {}

export const Icon: React.CFC<IconProps> = ({ ...props }) => {
  return <StyledIcon {...props} />
}
